/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState, useCallback } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { format } from 'date-fns';
import TableLoader from '../../../../components/TableLoader';
import Modal from '../../../../components/Modal';
import { Container } from './styles';
import Input from '../../../../components/Input';
import { useToast } from '../../../../hooks/toast';
import TicketService from '../../../../services/ticket';
import getValidationErrors from '../../../../utils/getValidationErrors';

interface ConfirmationModalProps {
  cardNumber: string;
  dataBloqueio: string;
  show: boolean;
  title: string;
  text: string;
  getDataBloqueio(date: string): void;
  getResponsible(name: string): void;
  setShowDuplicateLetter(duplicate: boolean): void;
  handleClose(): void;
  handleSuccess(): void;
}

const ModalBlock: React.FC<ConfirmationModalProps> = ({
  cardNumber,
  dataBloqueio,
  show,
  getDataBloqueio,
  getResponsible,
  handleClose,
  handleSuccess,
  setShowDuplicateLetter,
  title,
  text,
}) => {
  const formRef = useRef<FormHandles>(null);
  const services = { TicketService: new TicketService() };
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();
  console.log({ dataBloqueio });
  const schema = Yup.object().shape({
    name: Yup.string().required('Digite seu nome'),
  });

  const handleSubmit = useCallback(async (data: any) => {
    try {
      formRef.current?.setErrors({});
      await schema.validate(data, {
        abortEarly: false,
      });
      setLoading(true);
      await services.TicketService.blockCards(cardNumber, {
        CodigoDoMotivoDeBloqueio: '1',
        DescricaoBloqueio: data.name,
      });
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Cartão Bloqueado!!',
      });
      await handleSuccess();
      setLoading(false);
      const dataBlockCard = new Date();
      const dataBloqueioCard = format(dataBlockCard, 'dd/MM/yyyy');
      getDataBloqueio(dataBloqueioCard);
      getResponsible(data.name);
      setShowDuplicateLetter(true);
      handleClose();
    } catch (err: any) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
      }
    }
  }, []);

  return (
    <Container>
      <Modal title={title} handleClose={handleClose} show={show}>
        {loading ? (
          <TableLoader />
        ) : (
          <>
            <p className="bodyText">{text}</p>
            <p className="text">Nome do responsável pelo pedido de bloqueio:</p>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <Input name="name" type="text" schema={schema} />
              <div className="buttonsContainer">
                <button className="no" type="button" onClick={handleClose}>
                  Não
                </button>
                <button className="button" type="submit">
                  Sim, bloquear
                </button>
              </div>
            </Form>
          </>
        )}
      </Modal>
    </Container>
  );
};

export default ModalBlock;
